// extracted by mini-css-extract-plugin
export default {"flexContainer":"FlexContainer_flexContainer__aI6T0","blockScreen":"FlexContainer_blockScreen__mcqvm","unblockScreen":"FlexContainer_unblockScreen__+HShc"};